import { useState, useEffect } from "react";
import "./TrainPopupModal.css";
import Button from "../Buttons";
import { useTrainApiProvider } from "../../Services/TrainApiProvider";
import {
  CustomTextarea
} from "../../Components/CustomFormElements";

export default function TrainPopupModal({ messageId, onTrainDone }) {
  const { getMetadata, updateInstruction } = useTrainApiProvider();
  const [loading, setLoading] = useState(true);
  const [frames, setFrames] = useState([]);
  const [selectedFrameId, setSelectedFrameId] = useState(null);
  const [instructionsMap, setInstructionsMap] = useState({});

  useEffect(() => {
    const fetchFrames = async () => {
      setLoading(true);
      try {
        const response = await getMetadata(messageId);
        if (response?.frames?.length > 0) {
          setFrames(response.frames);
          setSelectedFrameId(response.frames[0].id);

          const initialInstructions = {};
          response.frames.forEach((frame) => {
            initialInstructions[frame.id] = frame.instruction || "";
          });
          setInstructionsMap(initialInstructions);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchFrames();
  }, [messageId]);

  const handleInstructionChange = (frameId, value) => {
    setInstructionsMap((prev) => ({
      ...prev,
      [frameId]: value
    }));
  };

  const onUpdateAll = async () => {
    const updates = frames.map((frame) =>
      updateInstruction(frame.id, instructionsMap[frame.id])
    );
    await Promise.all(updates);
    onTrainDone();
  };

  const onClose = () => {
    onTrainDone();
  };

  if (loading) {
    return <div className="train-modal" style={{ height: "300px" }} />;
  }

  const selectedFrame = frames.find((f) => f.id === selectedFrameId);

  return (
    <div className="train-modal">
      <div className="train-modal-body">
        <div className="train-tabs">
          {frames.map((frame) => (
            <div
              key={frame.id}
              className={`tab ${frame.id === selectedFrameId ? "active" : ""}`}
              onClick={() => setSelectedFrameId(frame.id)}
            >
              {frame.name}
            </div>
          ))}
        </div>

        <div className="train-content">
          {selectedFrame && (
            <>
              <label>Frame: {selectedFrame.name}</label>

              <CustomTextarea
                id={`frame-instruction-${selectedFrame.id}`}
                label="Instruction"
                name="instruction"
                type="text"
                addedText={instructionsMap[selectedFrame.id]}
                onChange={(value) =>
                  handleInstructionChange(selectedFrame.id, value)
                }
                resizable={false}
                height="200px"
              />
            </>
          )}
        </div>
      </div>

      <div className="modal-buttons">
        <Button
          variant="ghost"
          size="small"
          className="update-frame"
          onClick={onUpdateAll}
        >
          Update All Frames
        </Button>
        <Button
          variant="danger"
          size="small"
          className="cancel-train"
          onClick={onClose}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
}